<script setup lang="ts">
import { useAppStore } from '../store/modules/app.store'

const appStore = useAppStore()
</script>

<template>
  <v-card>
    <v-card-title>
      {{ appStore.title }}
    </v-card-title>

    <v-card-text>
      Version: {{ appStore.version }}
    </v-card-text>
  </v-card>
</template>
